import { SpeedrunGameResult } from "@shared/types";
import { css, html, htmlArray } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";

const styles: string = css``;

export class SpeedrunComponent extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    private startTime: number | null = null;
    private endTime: number | null = null;
    private isRunning: boolean = false;
    private storageKey: string = "speedrun-time";

    public getSpeedrunState(): void {
        void this._gameRouteService.getSpeedrunResult();
    }

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }
        this._gameRouteService.getSpeedrunResult().then((speedrunResult: SpeedrunGameResult) => {
            const speedrunTime: number = new Date(speedrunResult.endDate).getTime() - new Date(speedrunResult.startDate).getTime();
            console.log("Speedrun Time:", speedrunTime);
        }).catch((error: unknown) => {
            console.error("Failed to fetch speedrun result:", error);
        });

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>
            ${this.renderContent()}
        `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
    }

    private renderContent(): HTMLElement {
        return html`
            <div class="speedrun">
                <div id="time-display"></div>
            </div>
        `;
    }

    public start(): void {
        if (!this.isRunning) {
            this.startTime = Date.now();
            this.isRunning = true;
            localStorage.setItem(this.storageKey, JSON.stringify({ startTime: this.startTime, endTime: null }));
        }
    }

    public stop(confirm: boolean = false): void {
        if (this.isRunning) {
            this.endTime = Date.now();
            this.isRunning = false;
            localStorage.setItem(this.storageKey, JSON.stringify({ startTime: this.startTime, endTime: this.endTime }));

            if (confirm) {
                this.displayFinalTime();
            }
        }
    }

    private displayFinalTime(): void {
        if (this.startTime !== null && this.endTime !== null) {
            const elapsed: number = this.endTime - this.startTime;
            const minutes: number = Math.floor(elapsed / 60000);
            const seconds: number = Math.floor((elapsed % 60000) / 1000);
            const milliseconds: number = elapsed % 1000; // Keep milliseconds as an integer
            const formattedTime: string = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}:${String(milliseconds).padStart(3, "0")}`;

            console.log("Final Speedrun Time:", formattedTime);
        }
    }
}
